import React from "react";
import "../user-requests-filter-options/filter-options-user-requests.scss";
import { TextInputComponent } from "../../../../../common/components";

interface TextFilterProps {
  value: string;
  error?: string;
  onChange: (
    e: React.ChangeEvent<HTMLInputElement | HTMLTextAreaElement>
  ) => void;
  isLastNameEnabled: boolean;
}

const LastNameFilter: React.FC<TextFilterProps> = ({
  value,
  error,
  onChange,
  isLastNameEnabled,
}) => {
  if (!isLastNameEnabled) return null;

  return (
    <div className="tenant-filter-options-text-wrapper">
      <div className="filter-options-tenant-filters">
        <TextInputComponent
          type="text"
          fieldName="lastName"
          placeholder="Enter Last Name"
          optional={false}
          disabled={!isLastNameEnabled}
          value={value}
          onChange={onChange}
        />
      </div>
    </div>
  );
};

export default LastNameFilter;